import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { AuthService } from 'app/core/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { EncryptdecryptService } from 'app/shared/services/encryptdecrypt.service';
import { User } from 'app/core/user/user.types';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { UserService } from 'app/modules/user/user.service';
import { environment } from 'environment/environment';
// import { compactNavigationAdmin, compactNavigationCompany, compactNavigationEmployee, roles } from 'assets/i18n/data';

@Component({
    selector: 'classicenfinity-layout',
    templateUrl: './classicenfinity.component.html'
})
export class ClassicEnfinityLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    enfinityNavigation: FuseNavigationItem[];
    currentUser: any;
    roleFrom: FormGroup ;
    user: User;
    partnerName: string = "";
    encryptstring: string = "";
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @Input() showAvatar: boolean = true;
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private EncrDecr: EncryptdecryptService,       
         private _authService:AuthService,
          private _userService: UserService,
          private _formBuilder: UntypedFormBuilder,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
 
    ngOnInit(): void
    {  console.log("JSON.parse(this._authService.accessUser);",JSON.parse(this._authService.accessUser)  );
    
        this.user = JSON.parse(this._authService.accessUser);  
        this.roleFrom = this._formBuilder.group({
            UserID: [this.user.id]
          });
          this.partnerName =this.user.user_PartnerName;
          console.log("user.partnerName", this.user.user_PartnerName)
        //   if(this.user.partner_id == 1){
        //     this.partnerName = "Pozitive Water";
            
        //   }
        //   else{
        //     this.partnerName = this.user.partnerName;
        //   }
          this._userService.GetRoleDataById(this.roleFrom.value).subscribe(
            (res: any) => {

              console.log("menu bind-->", res);
              this.navigation = res;


            },
            (error) => {

              console.log(error);
            }
          );
        //Subscribe to navigation data
        // this._navigationService.navigation$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((navigation: Navigation) => {
        //         this.navigation = navigation;
        //     });
        // this.currentUser = JSON.parse(this._authService.accessUser);
        // console.log(this.currentUser.roles?.includes(roles.Company))
        // if (this.currentUser.roles?.includes(roles.Company)) {
        //     this.enfinityNavigation = compactNavigationCompany
        // }
        // else if (this.currentUser.roles?.includes(roles.Employee)) {
        //     this.enfinityNavigation = compactNavigationEmployee
        // }
        // else {
        //     this.enfinityNavigation = compactNavigationAdmin
        // }
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

            
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    openTickets(): void {
        const token = localStorage.getItem('accessToken') || '';
        const target = token
            ? `${environment.ticketingUrl}#token=${encodeURIComponent(token)}`
            : environment.ticketingUrl;
        window.open(target, '_blank', 'noopener,noreferrer');
    }

    signOut(): void {

        this._router.navigate(['/sign-out']);
    }

    changepassword(): void {

        this._router.navigate(['/change-password']);
    }

    userdetail(id: any): void {
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
                
                this.encryptstring = res.encryptedText;
                if (this.encryptstring != null && this.encryptstring != '') {
                    this._router.navigate(['/user/userdetail', this.encryptstring]);
                }
            })

        //let encodeID = this.EncrDecr.encryptUsingAES256(id);

    }
    partnerdetail(id: any): void {
       
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
                
                this.encryptstring = res.encryptedText;
                if (this.encryptstring != null && this.encryptstring != '') {
                    this._router.navigate(['/user/userdetail', this.encryptstring]);
                }
            })

    }

    Onimage(){
        this._router.navigate(['/dashboards/customer'])
    }

}

